import { CadyMarket } from '@/types/CadyMarket'

export enum routeName {
  HOME = 'home',
  // The five primary market landings are historically named after their market
  // value. Prefer the explicit `PRIMARY_MARKET_LANDING_ROUTE` map (below) and
  // `meta.cadyMarket` over relying on this name===value coincidence — a route's
  // name and its market are distinct concepts (see `MARKET_LANDING_SENIOR_PREORDER`,
  // a Senior route whose name is NOT `senior`). Identifiers ADR:
  // docs/features/2026.07.28-senior-preorder/decisions/2026.07.24-001-route-market-catalog-identifiers.md
  MARKET_LANDING_CAP_GOWN = CadyMarket.CapGown,
  MARKET_LANDING_GRADUATION = CadyMarket.Graduation,
  MARKET_LANDING_ATHLETIC = CadyMarket.Athletic,
  MARKET_LANDING_UNDERCLASS = CadyMarket.Underclass,
  MARKET_LANDING_SENIOR = CadyMarket.Senior,
  // Senior Preorder marketing-entry page. Deliberately NOT a `CadyMarket`
  // value (unlike the landings above) — it's a distinct senior sub-route, not a
  // market, so it must never be interchangeable with `CadyMarket.Senior`.
  MARKET_LANDING_SENIOR_PREORDER = 'senior-preorder',
  CATALOG_INDEX = 'catalog-index',
  CATALOG_FLOW_STEP = 'catalog-flow-step',
  PACKAGE_BUILDER = 'package-builder',
  YEARBOOK = 'yearbook',
  RETOUCHING = 'retouching',
  CART_CONFIGURE = 'cart-configure',
  CART_CHECKOUT = 'cart-checkout',
  CART_ORDER_COMPLETE_STRIPE = 'cart-order-complete-stripe',
  RECEIPT = 'receipt',
  ORDER_INSERT = 'order-insert',
  CUSTOMER_SERVICE_ORDER = 'customer-service-order',
  DEBUG_RESET_DATA = 'debug-reset-data',
  DEBUG_CART_FLYOUT_ENHANCEMENT = 'debug-cart-flyout-enhancement'
}

// Explicit market → primary-landing-route mapping. The single source for "send
// the customer to this market's main landing" (redirect targets, the Gallery
// commerce-step URL), replacing scattered `{ name: cadyMarket }` navigations
// that relied on the route-name===market-value coincidence. `senior-preorder`
// is intentionally NOT a primary landing, so Senior maps to `/senior`.
export const PRIMARY_MARKET_LANDING_ROUTE: Record<CadyMarket, routeName> = {
  [CadyMarket.CapGown]: routeName.MARKET_LANDING_CAP_GOWN,
  [CadyMarket.Graduation]: routeName.MARKET_LANDING_GRADUATION,
  [CadyMarket.Athletic]: routeName.MARKET_LANDING_ATHLETIC,
  [CadyMarket.Underclass]: routeName.MARKET_LANDING_UNDERCLASS,
  [CadyMarket.Senior]: routeName.MARKET_LANDING_SENIOR
}
